import { MessageType } from '../../constants';
/**
 * Create a PING responder handler (reply PONG).
 *
 * This is a shared building block for both client/server endpoints.
 */
export function createPingResponder(params) {
  var hub = params.hub,
    handledBy = params.handledBy,
    includeTargetId = params.includeTargetId;
  return (data, context) => {
    if (!context.source) return;
    /** Mark accepted so MessageDispatcher can auto-send ACK when requireAck === true */
    context.markAcceptedBy(handledBy);
    /** Reply PONG */
    hub.messageDispatcher.sendMessage(context.source, context.origin, MessageType.PONG, data.requestId, includeTargetId ? {
      targetId: data.creatorId
    } : undefined);
  };
}